<template>
  <div>
    <l-bg />
    <transition name="fade">
      <div :class="$style.right" v-if="stage >= 3">
        <l-player @progress="(p) => { progress[0] = p }" url="audio/511/51516485_8000hz.wav" color="green" title="Мелодия после оцифровки" />
        <l-player @progress="(p) => { progress[1] = p }" url="audio/511/51516485.wav" color="white" title="Исходная мелодия" />
        <l-tooltip :class="$style.question">
          В тренажере использован фрагмент песни Billie Eilish - Bad Guy. Фрагмент дан в информационных целях в соответствии с ст. <span :class="$style.nowrap">1274 ГК РФ</span>
        </l-tooltip>
      </div>
    </transition>
    <l-progress v-if="stage >= 3" :left="progress[0]" bgColor="#1BC544" />
    <l-progress v-if="stage >= 3" :left="progress[1]" />
    <l-stripes-horizontal :count="42">
      <div :class="$style.cols">
        <l-col
          v-for="(col, index) in cols"
          :key="index"
          :coef="42"
          :label="stage < 3 ? col.label : null"
          :ideal="col.ideal"
          :accuracy="0.02"
          :disabled="stage === 2 ? col.offline : true"
          :offline="stage === 2 ? col.offline : true"
          :right="col.right"
          :highlight="col.highlight"
          toLabel
          v-model="col.value"
        />
      </div>
      <img :class="$style.svg" src="./assets/vawe-test.png" v-if="stage >= 3" alt="">
      <svg :class="$style.svg" v-if="false" width="1460" height="346" viewBox="0 0 1460 346" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 177C4 177 60.1706 194.5 91.7049 162.5C110.612 143.314 119.58 106 128.732 106C148.158 106 136.506 302.718 174.036 302.718C211.567 302.718 206.416 157.982 232.908 157.982C259.4 157.982 263.079 240.795 291.043 240.795C319.007 240.795 321.215 30.4055 364.633 30.4055C408.051 30.4055 385.238 157.982 424.976 157.982C464.714 157.982 452.94 87.1063 482.376 87.1063C511.812 87.1063 519.171 330.323 555.965 330.323C592.76 330.323 590.552 231.842 614.101 231.842C637.649 231.842 644.273 325.846 675.18 325.846C706.088 325.846 714.918 69.9468 744.354 69.9468C773.79 69.9468 766.431 134.854 808.377 134.854C850.323 134.854 835.605 12.5 864.305 12.5C893.005 12.5 905.515 254.224 940.102 254.224C974.689 254.224 965.858 191.555 991.615 191.555C1017.37 191.555 1017.37 343.752 1057.11 344.498C1096.85 345.244 1098.32 146.045 1130.7 146.045C1163.08 146.045 1153.51 222.144 1188.1 222.144C1222.69 222.144 1214.59 58.0098 1248.44 58.0098C1282.29 58.0098 1248.44 183.144 1390.53 183.144H1460" stroke="#1BC54A" stroke-width="2"/>
        <path d="M1 191.5L100.535 112.346C104.073 109.532 108.461 108 112.983 108H120C131.046 108 140 116.954 140 128V274C140 285.046 148.954 294 160 294H171.5L171.733 276.73C171.881 265.79 180.791 257 191.732 257H207.5V171C207.5 159.954 216.454 151 227.5 151H247.5V182C247.5 193.046 256.454 202 267.5 202H283.5V212C283.5 223.046 292.454 232 303.5 232H315.5V69C315.5 57.9543 324.454 49 335.5 49H352V40.5C352 29.4543 360.954 20.5 372 20.5H392.5V131C392.5 142.046 401.454 151 412.5 151H423V131.5C423 120.454 431.954 111.5 443 111.5H458V92C458 80.9543 466.954 72 478 72H501V112.5C501 123.546 509.954 132.5 521 132.5H535.5V301.5C535.5 312.546 544.454 321.5 555.5 321.5H569V267C569 255.954 577.954 247 589 247H604.5L606.972 242.056C610.36 235.28 617.285 231 624.861 231H643.5V249C643.5 260.046 652.454 269 663.5 269H681V292.5C681 303.546 689.954 312.5 701 312.5H710.5V82C710.5 70.9543 719.454 62 730.5 62H751V62C751 71.1127 758.387 78.5 767.5 78.5H787V99.5C787 110.546 795.954 119.5 807 119.5H821V82C821 70.9543 829.954 62 841 62H856V22C856 10.9543 864.954 2 876 2H894.5V125.5C894.5 136.546 903.454 145.5 914.5 145.5H930.5V219.5C930.5 230.546 939.454 239.5 950.5 239.5H965V201C965 189.954 973.954 181 985 181H1002.5V196C1002.5 207.046 1011.45 216 1022.5 216H1038.5V315C1038.5 326.046 1047.45 335 1058.5 335H1073V227.5C1073 216.454 1081.95 207.5 1093 207.5H1109V155C1109 143.954 1117.95 135 1129 135H1146.5V141C1146.5 152.046 1155.45 161 1166.5 161H1182V187.5C1182 198.546 1190.95 207.5 1202 207.5H1216V71.5C1216 60.4543 1224.95 51.5 1236 51.5H1254.5V52C1254.5 63.0457 1263.45 72 1274.5 72H1290V117.5C1290 128.546 1298.95 137.5 1310 137.5H1326V163.5C1326 174.546 1334.95 183.5 1346 183.5H1440.5" stroke="white" stroke-opacity="0.5" stroke-width="3"/>
      </svg>

      <div :class="$style.button" v-if="stage === 4">
        <l-button @click="nextStage">Продолжить</l-button>
      </div>
    </l-stripes-horizontal>
    <l-popupMessage
      :items="messages"
      :task="task"
      @click="nextStage"
    />
  </div>
</template>
<script>
import { reactive, ref, watch } from '@vue/composition-api'

import { arr1, arr2, task } from './arrs'

import { pushPopup } from '@/utils/pushPopup'

import { ideal } from '../step3/data'

export default {
  name: 'step4',
  setup(props, { emit }) {
    const messages = ref([])
    const stage = ref(0)
    const progress = reactive({ 0: 0, 1: 0 })

    const isZero = i => i > 10 && i < 17

    const cols = ref(ideal.map((c, i) => ({
      ...c,
      label: isZero(i) ? Math.floor(c.value * 42) : undefined,
      ideal: c.value,
      offline: !isZero(i),
      value: isZero(i) ? 0 : c.value,
    })))

    const nextStage = () => {
      messages.value = []

      if (stage.value === 0) pushPopup(arr1, messages.value)

      if (stage.value === 2) pushPopup(arr2, messages.value)

      if (stage.value === 4) {
        emit('nextStep', 5)
        return
      }

      stage.value += 1
    }

    nextStage()

    watch(cols, () => {
      const zeroCols = cols.value.filter((c, i) => isZero(i))
      const success = zeroCols.every(c => c.value > 0)

      if (success) nextStage()
    }, { deep: true })

    return {
      progress,
      messages,
      stage,
      cols,

      task,

      nextStage,
    }
  },
}

</script>
<style lang="scss" module>
.cols {
  position: absolute;
  left: 11rem;
  right: 11rem;
  bottom: 2px;
  top: 2px;
  display: flex;
  align-items: flex-end;
  pointer-events: none;
}

.svg {
  width: 122rem;
  height: 36.86046512vh;
}

.right {
  position: absolute;
  top: 3rem;
  right: 3rem;
  z-index: 20000;
  display: flex;
  align-items: center;
  filter: drop-shadow(0 0 0.75rem rgba(#000, 0.1));
  text-shadow: 0 0 1rem rgba(#000, 0.1);

  & > * + * {
    margin-left: 3.4rem;
  }
}
.nowrap {
  white-space: nowrap;
}
.button {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
